// define a mixin object
export const panelValidation = {
  methods: {
    validatePanelRow(length, width, amount, lengthHasFinish, widthHasFinish) {
      if (!width || !length || !amount) {
        // No message needed ??
        return null
      }

      let material = !this.$store.getters.material ? false : this.$store.getters.material

      // Determine hasGrain from store
      let product = this.$store.getters.materialProduct
      let side1 = this.$store.getters.materialSide1
      let top = !side1 ? product : side1
      let hasGrain = top && top.grain && top.grain !== 'Geen' ? top.grain.toLowerCase() : false

      // Max and min sawing dimensions (15mm schoonzagen rondom)
      let maxSizeLength = material.total_length - 30
      let maxSizeWidth = material.total_width - 30

      // Default min sizes
      let minSizeLength, minSizeWidth

      if (hasGrain) {
        // Houtdecoren: vaste nerf richting (lengte altijd lang, breedte altijd kort)
        minSizeLength = 100
        minSizeWidth = 55
      } else {
        // Unidecoren: lengte is de lange zijde, breedte de korte
        if (parseFloat(width) > parseFloat(length)) {
          // Breedte is langer, dus omgewisseld
          minSizeLength = 55
          minSizeWidth = 100
        } else {
          minSizeLength = 100
          minSizeWidth = 55
        }
      }

      // If there is some finish selected (NOTE: No finish available = false, No finish selected = 0)
      let finish = !this.$store.getters.materialFinish ? false : this.$store.getters.materialFinish
      // console.log('finish', finish)
      if ((lengthHasFinish || widthHasFinish) && finish !== false) {
        // Determine which is the short side and if it has finish (rondom afbanden)
        let shortSideHasFinish
        let shortSide
        let lengthIsLong // true = length is de lange zijde, false = width is de lange zijde

        // Korte zijde is altijd de kleinste van de twee (ook bij nerfplaten)
        if (parseFloat(length) >= parseFloat(width)) {
          shortSide = parseFloat(width)
          shortSideHasFinish = widthHasFinish
          lengthIsLong = true
        } else {
          shortSide = parseFloat(length)
          shortSideHasFinish = lengthHasFinish
          lengthIsLong = false
        }

        // Calculate min sizes for finishing
        // Beperk shortSide tot 1200 voor de minLongSide berekening (anders krijg je onmogelijke min > max)
        let effectiveShortSide = Math.min(shortSide, 1200)
        let minLongSide, minShortSide

        if (hasGrain) {
          // Houtdecoren (zelfde waarden als unidecoren, aparte logica voor toekomstige wijzigingen)
          if (shortSideHasFinish) {
            // Rondom afbanden: breedte min 120mm, lengte ≥ breedte en min 200mm
            minShortSide = 120
            minLongSide = Math.max(200, effectiveShortSide)
          } else {
            // Alleen lange zijdes afbanden: breedte min 100mm, lengte ≥ breedte en min 200mm
            minShortSide = 100
            minLongSide = Math.max(200, effectiveShortSide)
          }
        } else {
          // Unidecoren
          if (shortSideHasFinish) {
            // Rondom afbanden: breedte min 120mm, lengte ≥ breedte en min 200mm
            minShortSide = 120
            minLongSide = Math.max(200, effectiveShortSide)
          } else {
            // Alleen lange zijdes afbanden: breedte min 100mm, lengte ≥ breedte en min 200mm
            minShortSide = 100
            minLongSide = Math.max(200, effectiveShortSide)
          }
        }

        // Assign to length/width based on which is long/short
        if (lengthIsLong) {
          minSizeLength = minLongSide
          minSizeWidth = minShortSide
        } else {
          minSizeLength = minShortSide
          minSizeWidth = minLongSide
        }
      }

      // Voer alle checks uit
      let lengthVal = parseFloat(length)
      let widthVal = parseFloat(width)

      let lengthTooLong = lengthVal > maxSizeLength
      let lengthTooShort = lengthVal < minSizeLength
      let widthTooWide = widthVal > maxSizeWidth
      let widthTooNarrow = widthVal < minSizeWidth
      let hasOneSideUnder1200 = lengthVal <= 1200 || widthVal <= 1200

      let lengthDecimalInvalid = false
      let widthDecimalInvalid = false
      if (!Number.isInteger(lengthVal)) {
        let decimal = Number((lengthVal - Math.trunc(lengthVal)).toFixed(2))
        lengthDecimalInvalid = decimal !== 0.5
      }
      if (!Number.isInteger(widthVal)) {
        let decimal = Number((widthVal - Math.trunc(widthVal)).toFixed(2))
        widthDecimalInvalid = decimal !== 0.5
      }

      // Bepaal melding op basis van prioriteit (1200 check eerst)
      let element = ''
      let message = ''

      if (!hasOneSideUnder1200) {
        element = 'width'
        message = 'Maximale paneelafmeting is behaald. Een van de twee lengtes moet onder de 1200 mm zijn'
      } else if (lengthTooLong) {
        element = 'length'
        message = 'Lengte mag maximaal ' + maxSizeLength + ' mm zijn'
      } else if (lengthTooShort) {
        element = 'length'
        message = 'Lengte moet minimaal ' + minSizeLength + ' mm zijn'
      } else if (widthTooWide) {
        element = 'width'
        message = 'Breedte mag maximaal ' + maxSizeWidth + ' mm zijn'
      } else if (widthTooNarrow) {
        element = 'width'
        message = 'Breedte moet minimaal ' + minSizeWidth + ' mm zijn'
      } else if (lengthDecimalInvalid) {
        element = 'length'
        message = 'Paneel afmeting alleen mogelijk met een nauwkeurigheid van 0.5 millimeter.'
      } else if (widthDecimalInvalid) {
        element = 'width'
        message = 'Paneel afmeting alleen mogelijk met een nauwkeurigheid van 0.5 millimeter.'
      }

      if (message !== '') {
        return [element, message]
      }

      return null
    }
  }
}
